const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Info",
    "termsOfService": "Nutzungsbedingungen",
    "privacyPolicy": "Datenschutzerklärung",
    "guaranteeOfRights": "Rechte von Datensubjekten",
    "customerSupport": "KUNDENSUPPORT",
    "cookiePolicy": "Cookie-Richtlinie",
    "declarationOfSafety": "Sicherheit・Sicherheitserklärung",
    "youthProtectionPolicy": "Erklärung über den Schutz der Jugend",
    "communityPolicy": "Communityrichtlinie",
    "probability": "probability",
    "operationPolicy": "Betriebsrichtlinie",
    "doNotSell": "Meine personenbezogenen Daten nicht verkaufen",
    "gameGrade": "Bewertung",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "Nutzungsbedingungen",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "Zustimmung zu NC-Diensten",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Zusätzliche Informationen gemäß den Glücksspielgesetzen",
    "brandInformation": "Informationen zum Unternehmensnamen",
    "copyright": "Copyright",
    "channelingInfo": "NC ist ein Zwischenhändler, der den E-Commerce von Channeling-Spielen innerhalb von plaync vermittelt, und ist keine Verkaufspartei der oben genannten Verkäufe.<br>Alle Verpflichtungen und Verantwortlichkeiten im Zusammenhang mit den angebotenen Channeling-Spielen liegen beim jeweiligen E-Commerce-Partner, und wir übernehmen keine Verantwortung für diesbezügliche Probleme."
  },
  "infoCS": {
    "businessInformation": "Unternehmensinformation",
    "infoAddress": "Name des Unternehmens: NC Corporation, Co-CEOs: Kim Taek-Jin, Park Byung-Moo, Handelsregisternummer: 220-81-43000, E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Adresse: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea. KUNDENSUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "pc": "Adresse: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea. KUNDENSUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "ncfamilyzone": "Adresse: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea. KUNDENSUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "other": "Adresse: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea. KUNDENSUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "none": "",
    "infoEmail": "E-Mail",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Titel",
    "jpGenre": "Genre",
    "jpPrice": "Preis",
    "jpPriceValue": "Gratis zum Spielen (enthält In-App-Käufe)",
    "jpOs": "Unterstütztes Betriebssystem",
    "jpPlatform": "Plattform",
    "jpDevelopedBy": "Entwickler/Herausgeber",
    "jpReleaseDay": "Veröffentlichungsdatum",
    "jpReleaseDayValue_LW": "04. November 2021"
  },
  "country": {
    "KR": "Korea, Republik",
    "TW": "Taiwan",
    "RU": "Russland",
    "MY": "Malaysia",
    "SA": "Saudi-Arabien",
    "SG": "Singapur",
    "AE": "Vereinigte Arabische Emirate",
    "ID": "Indonesien",
    "JP": "Japan",
    "QA": "Katar",
    "TH": "Thailand",
    "PH": "Philippinen",
    "HK": "Hongkong",
    "UA": "Ukraine",
    "BY": "Belarus",
    "LT": "Litauen",
    "PL": "Polen",
    "GR": "Griechenland",
    "IL": "Israel",
    "KW": "Kuwait",
    "AT": "Österreich",
    "US": "USA",
    "CA": "Kanada",
    "DE": "Deutschland",
    "GB": "Vereinigtes Königreich",
    "FR": "Frankreich",
    "BR": "Brasilien",
    "IT": "Italien",
    "ES": "Spanien",
    "CL": "Chile",
    "NO": "Norwegen",
    "SE": "Schweden",
    "IE": "Irland",
    "PT": "Portugal",
    "FI": "Finnland",
    "DK": "Dänemark",
    "CH": "Schweiz",
    "AR": "Argentinien",
    "PE": "Peru",
    "MX": "Mexiko",
    "KZ": "Kasachstan",
    "UZ": "Usbekistan",
    "AZ": "Aserbaidschan",
    "GE": "Georgien",
    "MD": "Moldau",
    "AM": "Armenien",
    "MO": "Macao",
    "IN": "Indien",
    "PK": "Pakistan",
    "NL": "Niederlande",
    "RO": "Rumänien",
    "AU": "Australien",
    "TR": "Türkei",
    "EC": "Ecuador",
    "CO": "Kolumbien",
    "ZA": "Südafrika",
    "EG": "Ägypten",
    "NC": "Global"
  }
};

export default l10n;
